export const DEFAULT_CATEGORY_NAMES: string[] = [
    'Proboszcz',
    'Wikariusz',
    'Rezydent',
    'Kancelaria',
    'Organista/Organistka',
    'Zakrystian/ka',
    'Katecheta/tka',
    'Schola',
    'Grabarz',
];

export const INITIAL_SETUP_DRAFT_STORAGE_KEY: string = 'todai-app.initial-setup.draft';
export const INITIAL_SETUP_AUTO_OPEN_DISMISSED_STORAGE_KEY: string = 'todai-app.initial-setup.auto-open-dismissed';

export const OPEN_INITIAL_SETUP_EVENT: string = 'todai-app.open-initial-setup';
export const OPEN_JOIN_EXISTING_PARISH_EVENT: string = 'todai-app.open-join-existing-parish';
